import {USER_INFO} from 'actions'

const reducer = (state = {}, {type, response}) => {
  switch (type) {
  case USER_INFO:
    return {...state, userInfo: response}
  default:
    return state
  }
}

export default reducer
